import { IPlayerGame } from "@grassrootly/api/entities";
import withErrorCheck from "../CheckError";
import server from "../Server";
import { GetPlayerPreviousGamesPayload } from '@grassrootly/api/gateways';

// Fetch the best previous game for a player using the 'player_games_view'.
// This uses server-side ordering and returns only 1 row.
export const GetPlayersBestGame = async ({ date_to, pid }: GetPlayerPreviousGamesPayload): Promise<IPlayerGame | null> => {
  // See GetPlayersPreviousGamesAlt for details about approximated ordering and view extension suggestions.
  const response = await server
    .from("player_games_view")
    .select([
      "group_name",
      "group_logo",
      "game_id",
      "game_type",
      "game_status",
      "game_datetime",
      "game_host_team_name",
      "game_visitor_team_name",
      "game_host_score",
      "game_visitor_score",
      "player_id",
      "player_attended",
      "player_rating",
      "player_outcome",
      "player_goals_scored",
      "player_assists_made",
      "player_position",
      "player_yellow_cards",
      "player_red_cards",
      "player_saves",
      "player_own_goals",
      "player_errors_leading_to_a_goal",
      "organization_logo",
      "season_summary",
      "host_team_logo",
      "visitor_team_logo",
    ].join(","))
    .eq("player_id", pid)
    .eq("player_attended", true)
    .lte("game_datetime", date_to)
    .order("player_rating", { ascending: false, nullsFirst: false })
    .order("player_goals_scored", { ascending: false, nullsFirst: false })
    .order("player_assists_made", { ascending: false, nullsFirst: false })
    .order("game_host_score", { ascending: false, nullsFirst: false })
    .order("game_visitor_score", { ascending: true, nullsFirst: false })
    .limit(1)
    .maybeSingle();

  const game = withErrorCheck<IPlayerGame | null>(response as any) || null;
  if (game) game.player_id = pid;
  return game;
};
